<!-- eslint-disable -->
<template>
  <div v-show="C_isVisible" class="panel-container">
    <div class="panel-button-container">
      <a 
        class="panel-button panel-button-mic" 
        :class="{active: C_isActiveState}"
        @mousedown="eventMouseDown(P_buttonOneId, P_buttonOneMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonOneId, P_buttonOneMakeSingleEvent)"
        @click="eventMouseClick(P_buttonOneId, P_buttonOneMakeSingleEvent)"
      >
        Speech
      </a>
    </div>
    <div :style="C_micBarStyle" class="panel-buttons-divider"></div>
    <div class="panel-button-container">
      <a 
        class="panel-button panel-button-decrease"
        @mousedown="eventMouseDown(P_buttonTwoId, P_buttonTwoMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonTwoId, P_buttonTwoMakeSingleEvent)"
        @click="eventMouseClick(P_buttonThreeId, P_buttonTwoMakeSingleEvent)"
      ></a>
    </div>
    <div class="panel-button-container">
      <a 
        class="panel-button panel-button-increase"
        @mousedown="eventMouseDown(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
        @click="eventMouseClick(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
      ></a>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: ['P_text', 'P_buttonOneId', 'P_buttonOneMakeSingleEvent', 'P_buttonTwoId','P_buttonTwoMakeSingleEvent', 'P_buttonThreeId', 'P_buttonThreeMakeSingleEvent'],
  data () {
    return {
      DV_micOFF: false
    }
  },
  mixins: [bi10GridComponent],
  computed: {
    C_micBarStyle() {
      const CI = this
      let val = 64;

      try {
        val = parseInt(CI.P_text);

        if (Object.is(val, NaN)) {
          val = 64;
        }
      } catch (err) {
        console.log("Undefined volume set.")
      }

      if (val > 100 ) { val = 100; }
      if (val < 1) { val = 1 }

      return {height: `${val}%`}
    }
  }
}
</script>

<style lang="less" scoped>
.panel-container {
  display: flex;
  border: 1px solid var(--border-color3);
  border-radius: 7px;
  padding: 6px;
  height: 100%;
  width: 100%;
  align-items: flex-end;
  .panel-button-container {
    width: 100%;
    height: 100%;
    .panel-button {
      display: block;
      height: 100%;
      width: 100%; 
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      &.panel-button-mic {
        display: flex;
        align-items: flex-end;
        color: var(--font-color1);
        justify-content: space-around;
        background-image: url(/dynamic/images/b1/NU_GUI/mic-on.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 60%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/mic-on.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
        &.active {
          background-image: url(/dynamic/images/b1/NU_GUI/mic-off-red-line.png), url(/dynamic/images/b1/NU_GUI/square-button-red.png);
          &:active {
            background-image: url(/dynamic/images/b1/NU_GUI/mic-off-red-line.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
          }
        }
      }
      &.panel-button-decrease {
        background-image: url(/dynamic/images/b1/NU_GUI/decrease.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 90%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/decrease.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
      }
      &.panel-button-increase {
        background-image: url(/dynamic/images/b1/NU_GUI/increase.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 75%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/increase.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
      }
    }
  }
  .panel-buttons-divider {
    width: 50px;
    background: var(--background-color3);
    border-radius: 5px;
    border-left: 1px solid var(--border-color1);
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/crestron/GMicPanel2.vue